import { ref, nextTick } from 'vue';
import { useRouter } from 'nuxt/app';

export const useTabBarNavigation = () => {
  const router = useRouter();
  const needScrollTop = ref<number | null>(null);
  let stopRuntimeHook: (() => void) | void | null = null;

  const navigateTo = (path: string, scrollYTop: number) => {
    router.push(path).catch((err) => {
      console.warn('Ошибка при переходе по маршруту:', err, path);
    });
    needScrollTop.value = scrollYTop;
    // initiateRuntimeHook();
    //
    // nextTick(() => {
    //   terminateRuntimeHook();
    // });
  };

  const adjustScrollPosition = () => {
    if (needScrollTop.value !== null) {
      window.scrollTo({ top: needScrollTop.value });
      needScrollTop.value = null;
    }
  };

  const initiateRuntimeHook = () => {
    if (!stopRuntimeHook) {
      stopRuntimeHook = useRuntimeHook('page:finish', () => {
        nextTick(() => {
          if (needScrollTop.value !== null) {
            setTimeout(adjustScrollPosition, 1);
          }
        });
      });
    }
  };

  const terminateRuntimeHook = () => {
    if (stopRuntimeHook) {
      stopRuntimeHook();
      stopRuntimeHook = null;
    }
  };

  initiateRuntimeHook();

  // onMounted(initiateRuntimeHook);
  // onUnmounted(terminateRuntimeHook);
  // onActivated(initiateRuntimeHook);
  // onDeactivated(terminateRuntimeHook);

  return {
    navigateTo,
    needScrollTop,
  };
};
